import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "admin-tag-list" }
const _hoisted_2 = { class: "tag-right-down" }
const _hoisted_3 = { class: "el-dropdown-link" }

import { useTabList } from '@/hooks/use-tag-list'
import { ArrowDown } from '@element-plus/icons-vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'admin-tag-list',
  setup(__props) {

const { activeTab, tabList, tabChange, removeTab, handleCloseTab } = useTabList()

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "tag-content",
      style: _normalizeStyle({ left: _ctx.$store.state.isCollapse ? '60px' : '210px' })
    }, [
      _createVNode(_component_el_tabs, {
        modelValue: _unref(activeTab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(activeTab) ? (activeTab).value = $event : null)),
        type: "card",
        class: "demo-tabs",
        onTabRemove: _unref(removeTab),
        onTabChange: _unref(tabChange),
        style: {"min-width":"10px"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabList), (item) => {
            return (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: item.path,
              label: item.title,
              name: item.path,
              closable: item.path != '/admin'
            }, null, 8, ["label", "name", "closable"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onTabRemove", "onTabChange"]),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_dropdown, { onCommand: _unref(handleCloseTab) }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "closeOthers" }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("关闭其他", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "closeAll" }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode("关闭全部", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_unref(ArrowDown))
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onCommand"])
      ])
    ], 4),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tag-content-shadow" }, null, -1))
  ]))
}
}

})